// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomerPage_wrapper__D70tc"};